// Import all your images
import teethCleaning from '../../assets/service/teethcleaningThumbnail.jpg';
import implants from '../../assets/service/dentalImplantThumbnail.jpg';
import rootcanal from '../../assets/service/root_canal_img.jpg';
import crownsbridges from '../../assets/service/CROWNANDBRIDGES.jpg';
import dentures from '../../assets/service/completeDentureTumbnail.jpg';
import BracesAligners from '../../assets/service/BracesAndAligners.jpg';
import teethWhitening from '../../assets/service/TeethWhiteningThumbnail.jpg';
import teethExtraction from '../../assets/service/teethExtraction.jpg';
import pediatric from '../../assets/service/pediatricDentistryThumbnail.jpg';
import veeners from '../../assets/service/veenersAndLaminatesThumbnail.jpg';


const ServicesData = [
    {   
        imageUrl: teethCleaning,
        title: 'Teeth Cleaning',
        slug: 'teeth-cleaning'
    },
    {
        imageUrl: rootcanal,
        title: 'Root Canal Treatment',
        slug: 'root-canal-treatment'
    },
    {
        imageUrl: implants,
        title: 'Dental Implants',
        slug: 'dental-implants'
    },
    {
        imageUrl: BracesAligners,
        title: 'Braces And Clear Aligners',
        slug: 'braces-clear-aligners'
    },
    {
        imageUrl: teethWhitening,
        title: 'Teeth Whitening',
        slug: 'teeth-whitening'
    },
    {
        imageUrl: crownsbridges,
        title: 'Crowns & Bridges',
        slug: 'crowns-and-bridges'
    },
    {
        imageUrl: teethExtraction,
        title: 'Teeth Extraction',
        slug: 'teeth-extraction'
    },
    {
        imageUrl: dentures,
        title: 'Complete Dentures',
        slug: 'complete-dentures'
    },
    {
        imageUrl:pediatric,
        title:'Pediatric & Preventive Dentistry',
        slug: 'pediatric-dentistry'
    },
    {
        imageUrl:veeners,
        title:'Veeners & Laminates',
        slug: 'veneers-laminates'
    }
];


export default ServicesData;
